import { Injectable, inject, signal } from "@angular/core";
import { Organisation } from "./organisation";
import { AuthService } from "./auth";
import { CachedApi } from "./cached-api";
import { logger } from "./logger";
import { toError } from "./utils/to-error";


@Injectable({
    providedIn: 'root'
})
export class OrganisationService {

    private api = inject(CachedApi);
    private auth = inject(AuthService);
    public currentOrganisation = signal<Organisation | null>(null);

    async fetchOrganisation() {
        const currentOrg = this.auth.currentOrganisation();
        if (currentOrg === null) {
            return;
        }

        try {
            const organisation = await this.api.get<Organisation>(`/organisations/${currentOrg}`);
            if (organisation.state === 'ok') {
                this.currentOrganisation.set(new Organisation(organisation.data));
            } else {
                this.currentOrganisation.set(null);
            }
        } catch (e) {
            logger.error('Failed to fetch organisation', toError(e));
            this.currentOrganisation.set(null);
        };
    }

    async ensureOrganisation() {
        if (this.currentOrganisation() === null) {
            await this.fetchOrganisation();
        }

        if (this.currentOrganisation()?.id !== this.auth.currentOrganisation()) {
            await this.fetchOrganisation();
            if (this.currentOrganisation() === null) {
                throw new Error('Organisation not found');
            }
        }

    }

    invalidateOrganisation() {
        this.currentOrganisation.set(null);
    }
}